import I18n from 'I18n';
import { List as ImmutableList } from 'immutable';
import { useCallback, useContext, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import { EVENTS } from 'reporting-ui-components/lib/events';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import useFetchDropdownOptionsForDimensionSelector from './useFetchDropdownOptionsForDimensionSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CheckboxTableDimensionSelector = ({
  selectedDimension,
  setSelectedDimension,
  reportDimensions,
  reportDataType
}) => {
  const {
    dropdownOptions
  } = useFetchDropdownOptionsForDimensionSelector(reportDimensions || ImmutableList([]), reportDataType);
  const {
    appUsageTracker,
    trackingAssetType,
    trackingApplicationName,
    trackingScreenName
  } = useContext(EnablementTrackingContext);
  const onDropdownChange = useCallback(({
    target: {
      value
    }
  }) => {
    appUsageTracker.track(EVENTS.selectDimension, {
      action: 'change-report-dimension',
      assetType: trackingAssetType,
      applicationName: trackingApplicationName,
      whereScreen: trackingScreenName,
      value
    });
    setSelectedDimension(value);
  }, [setSelectedDimension, appUsageTracker, trackingApplicationName, trackingAssetType, trackingScreenName]);
  useEffect(() => {
    if (dropdownOptions.length && (!selectedDimension ||
    // If the parent report's dimension has changed, the dropdown options have changed, reset the selected dimension
    !dropdownOptions.find(option => option.value === selectedDimension))) {
      setSelectedDimension(dropdownOptions[0].value);
    }
  }, [selectedDimension, setSelectedDimension, dropdownOptions]);
  if (!reportDimensions || !reportDimensions.size) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "checkbox-table-dimension-selector",
      padding: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-ui-components.singleReportViewer.checkboxTable.dimensionSelector.label"
      })
    }), /*#__PURE__*/_jsx(Select, {
      id: "checkbox-table-dimension-selector",
      "data-test-id": "checkbox-table-dimension-selector",
      disabled: dropdownOptions.length <= 1,
      buttonUse: "transparent",
      options: dropdownOptions,
      placeholder: I18n.text('reporting-ui-components.singleReportViewer.checkboxTable.dimensionSelector.placeholder'),
      value: selectedDimension,
      onChange: onDropdownChange,
      padding: "200"
    })]
  });
};
export default CheckboxTableDimensionSelector;